/** A target number without trailing zeros, in the UI language ("8,3" in German). */
export function formatTargetNumber(value: number, language: string): string {
  return new Intl.NumberFormat(language, { maximumFractionDigits: 3 }).format(value);
}
